import { render, staticRenderFns } from "./FaixasDesconto.vue?vue&type=template&id=a3cc9436&scoped=true&"
import script from "./FaixasDesconto.vue?vue&type=script&lang=js&"
export * from "./FaixasDesconto.vue?vue&type=script&lang=js&"
import style0 from "./FaixasDesconto.vue?vue&type=style&index=0&id=a3cc9436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cc9436",
  null
  
)

export default component.exports